/**
 * dropdown.js — thay <select> gốc của trình duyệt bằng dropdown tự vẽ cho ô sắp xếp (trang cửa hàng, hot deal).
 *
 * Markup: <label for="id">…</label> + <select id="id" data-dropdown [data-dropdown-icon="ph-…"]>.
 * Script bọc select trong div.dropdown, chèn button.dropdown__button (role=combobox) + ul.dropdown__menu
 * (role=listbox) rồi ẩn select. Select VẪN nằm trong form: gửi được orderby, và chưa có JS thì nó hiện như cũ.
 * Chọn một mục = gán select.selectedIndex rồi bắn "change" (bubbles) trên chính select — filters.js, hotdeal.js
 * và jQuery của WooCommerce (woocommerce.js: .woocommerce-ordering select.orderby change → submit form) đều đang
 * nghe sự kiện đó, nên không phải sửa gì ở chúng. Code khác đổi select rồi bắn "change" thì nút tự cập nhật.
 *
 * Bàn phím theo mẫu "select-only combobox" của WAI-ARIA APG: focus luôn nằm ở nút, mục đang trỏ báo cho
 * trình đọc màn hình bằng aria-activedescendant. Đóng: ↓ ↑ Enter Space mở. Mở: ↓ ↑ Home End di chuyển,
 * Enter / Space chọn, Esc đóng, Tab chọn mục đang trỏ rồi đi tiếp, gõ chữ cái nhảy tới mục bắt đầu bằng chữ đó
 * (bỏ dấu: gõ "g" tới "Giá tăng dần").
 * Chuột / chạm: chặn mousedown trên danh sách để nút không mất focus — không thì danh sách đóng (blur) trước khi
 * click kịp chọn. Bấm ra ngoài thì đóng. Phía dưới thiếu chỗ (sát thanh đáy mobile) thì mở lên trên (.is-up).
 *
 * WP: giữ nguyên file. woocommerce_catalog_ordering() in sẵn select.orderby — chỉ cần thêm data-dropdown
 * (override loop/orderby.php, đã override để có nhãn).
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var selects = [].slice.call(document.querySelectorAll('select[data-dropdown]'));
    if (!selects.length) return;

    var uid = 0;

    // So khớp gõ chữ không phân biệt dấu: "gia" khớp "Giá", "d" khớp "Đánh giá"
    function fold(text) {
        text = String(text).toLowerCase().replace(/đ/g, 'd');
        return text.normalize ? text.normalize('NFD').replace(/[̀-ͯ]/g, '') : text;
    }

    function emit(el, name) {
        var event;
        try {
            event = new Event(name, { bubbles: true });
        } catch (e) {
            event = document.createEvent('Event');
            event.initEvent(name, true, false);
        }
        el.dispatchEvent(event);
    }

    function enhance(select) {
        var id = select.id || 'dropdown-' + ++uid;
        select.id = id;
        var label = document.querySelector('label[for="' + id + '"]');

        var wrap = document.createElement('div');
        wrap.className = 'dropdown';
        select.parentNode.insertBefore(wrap, select);
        wrap.appendChild(select);
        select.classList.add('dropdown__native');
        select.hidden = true;

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'dropdown__button';
        button.id = id + '-button';
        button.setAttribute('role', 'combobox');
        button.setAttribute('aria-haspopup', 'listbox');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', id + '-listbox');

        var list = document.createElement('ul');
        list.className = 'dropdown__menu';
        list.id = id + '-listbox';
        list.setAttribute('role', 'listbox');
        list.setAttribute('tabindex', '-1');

        // Nhãn trỏ sang nút: bấm chữ "Sắp xếp" là mở, và nút lấy nhãn làm tên đọc (giá trị là chữ trong nút)
        if (label) {
            if (!label.id) label.id = id + '-label';
            label.htmlFor = button.id;
            button.setAttribute('aria-labelledby', label.id);
            list.setAttribute('aria-labelledby', label.id);
        } else {
            button.setAttribute('aria-label', select.getAttribute('aria-label') || 'Sắp xếp');
        }

        var icon = select.getAttribute('data-dropdown-icon');
        button.innerHTML =
            (icon ? '<i class="ph-bold ' + icon + ' dropdown__icon" aria-hidden="true"></i>' : '') +
            '<span class="dropdown__value"></span>' +
            '<i class="ph-bold ph-caret-down dropdown__caret" aria-hidden="true"></i>';
        var value = button.querySelector('.dropdown__value');

        var options = [].slice.call(select.options).map(function (opt, i) {
            var li = document.createElement('li');
            li.className = 'dropdown__option';
            li.id = id + '-option-' + i;
            li.setAttribute('role', 'option');
            li.innerHTML = '<span></span><i class="ph-bold ph-check" aria-hidden="true"></i>';
            li.firstChild.textContent = opt.textContent;
            list.appendChild(li);
            return li;
        });

        wrap.insertBefore(button, select);
        wrap.insertBefore(list, select);

        var active = 0;
        var typed = '';
        var typedTimer;

        function sync() {
            var index = select.selectedIndex;
            options.forEach(function (li, i) {
                li.setAttribute('aria-selected', i === index ? 'true' : 'false');
            });
            value.textContent = index > -1 ? select.options[index].textContent : '';
        }

        function setActive(i) {
            active = Math.max(0, Math.min(options.length - 1, i));
            options.forEach(function (li, k) {
                li.classList.toggle('is-active', k === active);
            });
            button.setAttribute('aria-activedescendant', options[active].id);
            // Danh sách dài hơn khung (chưa có, phòng khi thêm mục): kéo mục đang trỏ vào tầm nhìn
            var li = options[active];
            if (li.offsetTop < list.scrollTop) list.scrollTop = li.offsetTop;
            else if (li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) {
                list.scrollTop = li.offsetTop + li.offsetHeight - list.clientHeight;
            }
        }

        function isOpen() {
            return wrap.classList.contains('is-open');
        }

        function outside(event) {
            if (!wrap.contains(event.target)) close();
        }

        function open() {
            if (isOpen()) return;
            // Danh sách ẩn bằng visibility nên vẫn đo được chiều cao. Thanh đáy mobile (fixed) che phần dưới
            // màn hình — đúng bằng padding-bottom của body (layout/_bottom-bar.scss)
            wrap.classList.remove('is-up');
            var rect = button.getBoundingClientRect();
            var cover = parseFloat(window.getComputedStyle(document.body).paddingBottom) || 0;
            var needed = list.offsetHeight + 12;
            if (window.innerHeight - cover - rect.bottom < needed && rect.top > needed) wrap.classList.add('is-up');

            wrap.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
            setActive(select.selectedIndex < 0 ? 0 : select.selectedIndex);
            document.addEventListener('pointerdown', outside, true);
        }

        function close() {
            if (!isOpen()) return;
            wrap.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
            button.removeAttribute('aria-activedescendant');
            document.removeEventListener('pointerdown', outside, true);
        }

        function choose(i) {
            var changed = select.selectedIndex !== i;
            select.selectedIndex = i;
            sync();
            close();
            if (changed) {
                emit(select, 'input');
                emit(select, 'change');
            }
        }

        function typeahead(ch) {
            window.clearTimeout(typedTimer);
            typed += fold(ch);
            typedTimer = window.setTimeout(function () {
                typed = '';
            }, 600);
            // Gõ lại cùng một chữ thì đi tiếp tới mục sau bắt đầu bằng chữ đó
            var start = typed.length === 1 ? active + 1 : active;
            for (var n = 0; n < options.length; n++) {
                var i = (start + n) % options.length;
                if (fold(options[i].textContent).indexOf(typed) === 0) {
                    setActive(i);
                    return;
                }
            }
        }

        function printable(event) {
            return event.key && event.key.length === 1 && event.key !== ' ' && !event.ctrlKey && !event.metaKey && !event.altKey;
        }

        button.addEventListener('click', function () {
            if (isOpen()) close();
            else open();
        });

        button.addEventListener('keydown', function (event) {
            var key = event.key;
            if (!isOpen()) {
                if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter' || key === ' ' || key === 'Spacebar') {
                    event.preventDefault();
                    open();
                } else if (printable(event)) {
                    open();
                    typeahead(key);
                }
                return;
            }
            switch (key) {
                case 'ArrowDown':
                    event.preventDefault();
                    setActive(active + 1);
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    setActive(active - 1);
                    break;
                case 'Home':
                case 'PageUp':
                    event.preventDefault();
                    setActive(0);
                    break;
                case 'End':
                case 'PageDown':
                    event.preventDefault();
                    setActive(options.length - 1);
                    break;
                case 'Enter':
                case ' ':
                case 'Spacebar':
                    event.preventDefault();
                    choose(active);
                    break;
                case 'Escape':
                case 'Esc':
                    // Không để Esc lan lên drawer / modal đang chứa dropdown
                    event.preventDefault();
                    event.stopPropagation();
                    close();
                    break;
                case 'Tab':
                    choose(active);
                    break;
                default:
                    if (printable(event)) {
                        event.preventDefault();
                        typeahead(key);
                    }
            }
        });

        // Space kích hoạt <button> lúc nhả phím — chặn để không bấm thêm lần nữa sau khi keydown đã xử lý
        button.addEventListener('keyup', function (event) {
            if (event.key === ' ' || event.key === 'Spacebar') event.preventDefault();
        });

        button.addEventListener('blur', function (event) {
            if (!event.relatedTarget || !wrap.contains(event.relatedTarget)) close();
        });

        list.addEventListener('mousedown', function (event) {
            event.preventDefault();
        });

        list.addEventListener('mousemove', function (event) {
            var li = event.target.closest ? event.target.closest('.dropdown__option') : null;
            if (li && !li.classList.contains('is-active')) setActive(options.indexOf(li));
        });

        list.addEventListener('click', function (event) {
            var li = event.target.closest ? event.target.closest('.dropdown__option') : null;
            if (li) choose(options.indexOf(li));
        });

        select.addEventListener('change', sync);
        sync();
    }

    selects.forEach(enhance);
})();
